import styled from 'styled-components';
import { showAnimation } from '../../commons/showAnimation';
export var Inner = styled.span.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-9gnymv-0"
})(["display:inline-block;position:relative;"]);
export var ActionHandler = styled.div.withConfig({
  displayName: "partials__ActionHandler",
  componentId: "sc-9gnymv-1"
})(["cursor:pointer;svg{vertical-align:sub;}"]);
export var Option = styled.div.withConfig({
  displayName: "partials__Option",
  componentId: "sc-9gnymv-2"
})(["padding:0 9px;font-size:11px;cursor:pointer;line-height 24px;user-select:none;svg{vertical-align:sub;}svg + span{padding-left:6px;}+ div{border-top:1px solid #eee;}&:hover{background-color:", ";color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiLL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
export var Menu = styled.div.withConfig({
  displayName: "partials__Menu",
  componentId: "sc-9gnymv-3"
})(["position:absolute;z-index:30;min-width:150px;margin-top:5px;", ";", ";opacity:1;text-align:left;", ";"], function (_ref3) {
  var posX = _ref3.posX;
  return posX === 'top' ? 'bottom: 100%' : 'top: 100%;';
}, function (_ref4) {
  var posY = _ref4.posY;
  return posY === 'right' ? 'right: 0;' : posY === 'center' ? 'left: 50%; margin-left: -165px;' : 'left: 0;';
}, showAnimation);